import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAssetElement } from './au-asset.model';
import { NgClass } from '@angular/common';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
	selector: 'au-asset-element',
	templateUrl: 'au-asset-element.component.html',
	styleUrls: ['au-asset-element.component.scss'],
	imports: [CdkDrag, MatIcon, CdkDragHandle, NgClass, MatCheckbox],
})
export class AuAssetElementComponent {
	@Input() asset: IAssetElement;
	@Input() canDelete = false;
	@Input() canMove = true;
	@Input() icon = 'sensor';
	@Input() selected: boolean;
	@Input() isSelectable: boolean;
	@Input() isVisible = true;
	@Input() isInstalled = false;

	@Output()
	chooseAsset = new EventEmitter<any>();
	@Output()
	selectAsset = new EventEmitter<any>();
	@Output() deleteAsset = new EventEmitter<any>();

	onSelectAsset(): void {
		this.selectAsset.emit(this.asset);
	}

	onChooseAsset(): void {
		this.chooseAsset.emit(this.asset);
	}

	onDelete(): void {
		this.deleteAsset.next(this.asset);
	}
}
